import React from 'react';

const APITable: React.FC = () => (
  // TODO: implement api table, depend on the new markdown data structure passed
  <>API Table</>
);

export default APITable;
